import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/CreateMyCvButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[lng]/_components/Post/gh-content.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/_components/Post/InjectResume.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[lng]/_components/Post/kg-card.css");
;
import(/* webpackMode: "eager" */ "/app/app/[lng]/_components/Post/post.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/blog/_components/BlogNav.tsx");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/LoginButtonGroup/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Preview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/region-tips/RegionTips.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.24.5_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.24.5_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.24.5_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/script.js");
